import { IgTypography } from "@intelligems/ig-theme";
import { Stack } from "@mui/material";

import type { RuleListUsage } from "../rules/ruleListRows";
import { UsedIn } from "../rules/UsedIn";

interface RuleMetaBylineProps {
  /** `null` when placements or assignments could not be loaded. */
  usedIn: RuleListUsage[] | null;
}

/**
 * "Used in" is the answer to the question a merchant actually has before
 * editing — how many places this change lands. It is the same component the
 * rules list uses, so the two screens can never disagree about the count.
 *
 * The "Used in" prefix only reads as a sentence when there are placements to
 * name after it, so the degraded states stand alone: "Not used yet" when the
 * join came back empty, "Usage unavailable" when it could not be loaded.
 */
export const RuleMetaByline = ({ usedIn }: RuleMetaBylineProps) => {
  if (usedIn === null) {
    return (
      <IgTypography color="text.tertiary" variant="body1">
        Usage unavailable
      </IgTypography>
    );
  }

  if (usedIn.length === 0) {
    return (
      <IgTypography color="text.tertiary" variant="body1">
        Not used yet
      </IgTypography>
    );
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IgTypography color="text.tertiary" variant="body1">
        Used in
      </IgTypography>
      <UsedIn usages={usedIn} showAll />
    </Stack>
  );
};
